<template>
<div>
  <div v-if="$store.state.trimestral == false">
    <div>
      <div v-for="(item,z) in 13" :key="z">
        <div v-if="mes == z">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[z-1][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">
            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>    
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      </div>
      
      
    </div>
  </div>
  <div v-if="$store.state.trimestral == true">
    <div>
      <div v-if="mes == 1">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[0][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">
            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>    
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 2">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[3][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>   
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 3">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[6][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 4">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[9][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 5">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[1][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 6">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[5][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 7">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[2][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 8">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[7][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 9">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[8][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 10">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[4][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 11">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[10][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
      <div v-if="mes == 12">
        <div v-for="(item,i) in api" :key="i">
          <div class="input-gray">
            <div class="input-title">
              <p>{{ item.titulo }}</p>
            </div>
            <money
              style="margin-right: 25px; max-width: 200px;"
              class="primary-input"
              v-bind="money"
              v-model="$store.state.meses[11][passomes-1][i].valor"
              :disabled="item.input == false"
            ></money>
            <div style="width:45px;" v-if="item.info == ''">

            </div>
            <div v-else>
              <i
              v-b-popover.hover.top="item.info == '' ? 'Sem informação' : item.info"
              title="Informação"
              id="popover-info"        
              class="fas fa-info-circle input-info"
            ></i>
            </div>  
            
          </div>
          <div v-if="passomes == 7 && i == 6" style="margin: 15px"><br></div>
        </div>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
import { Money } from "v-money";
import EventBus from "../event-bus";
export default {
  data() {
    return {
      price: 0,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
        valueTotal: 0,
      },
    };
  },

  computed: {},

  methods: {
    replicar(atualmes, replicarmes) {
      for(var z = 1; z <= 12; z++){
        if (replicarmes == z || replicarmes == 13) {
        if(this.passomes == 6){
          for(var i = 0; i < atualmes[this.passomes-1].length; i++){
            if(i == 0 || i == 1 ){
              this.$store.state.meses[z-1][this.passomes-1][i].valor = atualmes[this.passomes-1][i].valor
            }else{    
            }
          }
        }else{
          for(var i = 0; i < this.$store.state.meses[z-1][this.passomes-1].length; i++){
            this.$store.state.meses[z-1][this.passomes-1][i].valor = atualmes[this.passomes-1][i].valor
          }
        }
        this.$store.state.month = z;
      }
      }
    },
  },
  mounted() {
    EventBus.$on("replicar", (replicarmes, mesatual) => {
      if (mesatual == replicarmes) {
      } else {      
        for(var i = 1; i <= 12; i++){
          if (mesatual == i) this.replicar(this.$store.state.meses[i-1], replicarmes);
        }
      }
    });
  },
  beforeDestroy(){
    if(this.$store.state.resultado == false){
      this.$store.commit('increment')
      this.$store.state.resultado = true;
    }
  },
  created() { //criando os valores na variavel $store.state.meses de acordo com o numero de inputs criados

  
  for (var u = 0; u < 12; u++) {
      if (this.mes == u && this.$store.state.meses[u][this.passomes - 1].length == 0) {
      for (var e = 0; e < this.api.length; e++) {
          if(this.api[e].value){
          if(this.$store.state.trimestral == false){
          for (var i = 0; i < 12; i++) {
            this.$store.state.meses[i][this.passomes - 1].push({ valor: this.api[e].value[i+1] ? this.api[e].value[i+1] : 0});
          }
          }else{
          this.$store.state.meses[0][this.passomes - 1].push({ valor: this.api[e].value[0] ? this.api[e].value[0] : 0});
          this.$store.state.meses[1][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[2][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[3][this.passomes - 1].push({ valor: this.api[e].value[1] ? this.api[e].value[1] : 0 });
          this.$store.state.meses[4][this.passomes - 1].push({ valor:  0 });
          this.$store.state.meses[5][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[6][this.passomes - 1].push({ valor: this.api[e].value[2] ? this.api[e].value[2] : 0 });
          this.$store.state.meses[7][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[8][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[9][this.passomes - 1].push({ valor: this.api[e].value[3] ? this.api[e].value[3] : 0 });
          this.$store.state.meses[10][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[11][this.passomes - 1].push({ valor: 0 });
          }
          }else{
          for (var i = 0; i < 12; i++) {
          this.$store.state.meses[i][this.passomes - 1].push({ valor: 0 });
          }
          }
      }
    }
    }  

    for(let i = 0; i < 12; i++){
    
    if(this.$store.state.monthstep >= 4){
            this.$store.state.meses[i][5][3].valor =
            this.$store.state.resultadodeducao.deducoes.icms[i].valor +
            this.$store.state.resultadodeducao.deducoes.piS_LP[i].valor +
            this.$store.state.resultadodeducao.deducoes.cofinS_LP[i].valor +
            this.$store.state.resultadodeducao.deducoes.iss[i].valor +
            this.$store.state.meses[i][5][0].valor +
            this.$store.state.meses[i][5][1].valor;

            this.$store.state.meses[i][5][2].valor =
            this.$store.state.resultadodeducao.deducoes.icms[i].valor +
            this.$store.state.resultadodeducao.deducoes.piS_LR[i].valor +
            this.$store.state.resultadodeducao.deducoes.cofinS_LR[i].valor +
            this.$store.state.resultadodeducao.deducoes.iss[i].valor +
            this.$store.state.meses[i][5][0].valor +
            this.$store.state.meses[i][5][1].valor;
            }
        
      //calculando totais dos 2 campos do passo 7 <<

        
          this.$store.state.meses[i][6][9].valor = this.$store.state.meses[i][6][6].valor;

            this.$store.state.meses[i][6][7].valor =
            this.$store.state.meses[i][6][0].valor +
            this.$store.state.meses[i][6][1].valor -
            this.$store.state.meses[i][6][2].valor;
            this.$store.state.meses[i][6][8].valor =
            this.$store.state.meses[i][6][3].valor +
            this.$store.state.meses[i][6][4].valor -
            this.$store.state.meses[i][6][5].valor;
        
      
      //calculando totais dos 2 campos do passo 8 <<

       
          this.$store.state.meses[i][7][10].valor =
            this.$store.state.meses[i][7][0].valor +
            this.$store.state.meses[i][7][1].valor +
            this.$store.state.meses[i][7][2].valor +
            this.$store.state.meses[i][7][3].valor +
            this.$store.state.meses[i][7][4].valor +
            this.$store.state.meses[i][7][5].valor +
            this.$store.state.meses[i][7][6].valor +
            this.$store.state.meses[i][7][7].valor +
            this.$store.state.meses[i][7][8].valor +
            this.$store.state.meses[i][7][9].valor;
        
      
      //calculando totais dos 2 campos do passo 9 <<

       
           this.$store.state.meses[i][8][3].valor =
           this.$store.state.meses[i][8][1].valor * 0.08;
           this.$store.state.meses[i][8][4].valor =
           (this.$store.state.meses[i][8][0].valor +
              this.$store.state.meses[i][8][1].valor +
              this.$store.state.meses[i][8][2].valor) *
              0.2 +
            this.$store.state.meses[i][8][1].valor * 0.088;
            this.$store.state.meses[i][8][5].valor =
            this.$store.state.meses[i][8][0].valor +
            this.$store.state.meses[i][8][1].valor +
            this.$store.state.meses[i][8][2].valor +
            this.$store.state.meses[i][8][3].valor +
            this.$store.state.meses[i][8][4].valor;
        
      
      //calculando totais dos 2 campos do passo 12 <<


          this.$store.state.meses[i][11][9].valor =
            this.$store.state.meses[i][9][0].valor +
            this.$store.state.meses[i][9][1].valor +
            this.$store.state.meses[i][9][2].valor +
            this.$store.state.meses[i][9][3].valor +
            this.$store.state.meses[i][9][4].valor +
            this.$store.state.meses[i][9][5].valor +
            this.$store.state.meses[i][9][6].valor +
            this.$store.state.meses[i][9][7].valor +
            this.$store.state.meses[i][9][8].valor +
            this.$store.state.meses[i][9][9].valor +
            this.$store.state.meses[i][10][0].valor +
            this.$store.state.meses[i][10][1].valor +
            this.$store.state.meses[i][10][2].valor +
            this.$store.state.meses[i][10][3].valor +
            this.$store.state.meses[i][10][4].valor +
            this.$store.state.meses[i][10][5].valor +
            this.$store.state.meses[i][10][6].valor +
            this.$store.state.meses[i][10][7].valor +
            this.$store.state.meses[i][10][8].valor +
            this.$store.state.meses[i][10][9].valor +
            this.$store.state.meses[i][11][0].valor +
            this.$store.state.meses[i][11][1].valor +
            this.$store.state.meses[i][11][2].valor +
            this.$store.state.meses[i][11][3].valor +
            this.$store.state.meses[i][11][4].valor +
            this.$store.state.meses[i][11][5].valor +
            this.$store.state.meses[i][11][6].valor +
            this.$store.state.meses[i][11][7].valor +
            this.$store.state.meses[i][11][8].valor;

            this.$store.state.meses[i][11][10].valor =
            this.$store.state.meses[i][6][7].valor +
            this.$store.state.meses[i][6][8].valor +
            this.$store.state.meses[i][6][9].valor +
            this.$store.state.meses[i][7][10].valor +
            this.$store.state.meses[i][8][5].valor +
            this.$store.state.meses[i][11][9].valor;
        
      //calculando totais dos 2 campos do passo 13 <<

        
          this.$store.state.meses[i][12][18].valor =
            this.$store.state.meses[i][12][0].valor +
            this.$store.state.meses[i][12][1].valor +
            this.$store.state.meses[i][12][2].valor +
            this.$store.state.meses[i][12][3].valor +
            this.$store.state.meses[i][12][4].valor +
            this.$store.state.meses[i][12][5].valor +
            this.$store.state.meses[i][12][6].valor +
            this.$store.state.meses[i][12][7].valor +
            this.$store.state.meses[i][12][8].valor +
            this.$store.state.meses[i][12][9].valor +
            this.$store.state.meses[i][12][10].valor +
            this.$store.state.meses[i][12][11].valor +
            this.$store.state.meses[i][12][12].valor +
            this.$store.state.meses[i][12][13].valor +
            this.$store.state.meses[i][12][14].valor +
            this.$store.state.meses[i][12][15].valor +
            this.$store.state.meses[i][12][16].valor +
            this.$store.state.meses[i][12][17].valor;
        
      
      //calculando totais dos 2 campos do passo 14 <<

        
            this.$store.state.meses[i][13][12].valor =
            this.$store.state.meses[i][13][0].valor +
            this.$store.state.meses[i][13][1].valor +
            this.$store.state.meses[i][13][2].valor +
            this.$store.state.meses[i][13][3].valor +
            this.$store.state.meses[i][13][4].valor +
            this.$store.state.meses[i][13][5].valor +
            this.$store.state.meses[i][13][6].valor +
            this.$store.state.meses[i][13][7].valor +
            this.$store.state.meses[i][13][8].valor +
            this.$store.state.meses[i][13][9].valor +
            this.$store.state.meses[i][13][10].valor +
            this.$store.state.meses[i][13][11].valor;
  }
  },

  beforeUpdate() { //criando os valores na variavel $store.state.meses de acordo com o numero de inputs criados
  for (var u = 0; u < 12; u++) {
      if (this.mes == u && this.$store.state.meses[u][this.passomes - 1].length == 0) {
      for (var e = 0; e < this.api.length; e++) {
          if(this.api[e].value){
          if(this.$store.state.trimestral == false){
          for (var i = 0; i < 12; i++) {
            this.$store.state.meses[i][this.passomes - 1].push({ valor: this.api[e].value[i+1] ? this.api[e].value[i+1] : 0});
          }
          }else{
          this.$store.state.meses[0][this.passomes - 1].push({ valor: this.api[e].value[0] ? this.api[e].value[0] : 0});
          this.$store.state.meses[1][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[2][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[3][this.passomes - 1].push({ valor: this.api[e].value[1] ? this.api[e].value[1] : 0 });
          this.$store.state.meses[4][this.passomes - 1].push({ valor:  0 });
          this.$store.state.meses[5][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[6][this.passomes - 1].push({ valor: this.api[e].value[2] ? this.api[e].value[2] : 0 });
          this.$store.state.meses[7][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[8][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[9][this.passomes - 1].push({ valor: this.api[e].value[3] ? this.api[e].value[3] : 0 });
          this.$store.state.meses[10][this.passomes - 1].push({ valor: 0 });
          this.$store.state.meses[11][this.passomes - 1].push({ valor: 0 });
          }
          }else{
          for (var i = 0; i < 12; i++) {
          this.$store.state.meses[i][this.passomes - 1].push({ valor: 0 });
          }
          }
      }
    }
    }

  for(let i = 0; i < 12; i++){
    
    if(this.$store.state.monthstep >= 4){
            this.$store.state.meses[i][5][3].valor =
            this.$store.state.resultadodeducao.deducoes.icms[i].valor +
            this.$store.state.resultadodeducao.deducoes.piS_LP[i].valor +
            this.$store.state.resultadodeducao.deducoes.cofinS_LP[i].valor +
            this.$store.state.resultadodeducao.deducoes.iss[i].valor +
            this.$store.state.meses[i][5][0].valor +
            this.$store.state.meses[i][5][1].valor;

            this.$store.state.meses[i][5][2].valor =
            this.$store.state.resultadodeducao.deducoes.icms[i].valor +
            this.$store.state.resultadodeducao.deducoes.piS_LR[i].valor +
            this.$store.state.resultadodeducao.deducoes.cofinS_LR[i].valor +
            this.$store.state.resultadodeducao.deducoes.iss[i].valor +
            this.$store.state.meses[i][5][0].valor +
            this.$store.state.meses[i][5][1].valor;
            }
        
      //calculando totais dos 2 campos do passo 7 <<

        
          this.$store.state.meses[i][6][9].valor = this.$store.state.meses[i][6][6].valor;

            this.$store.state.meses[i][6][7].valor =
            this.$store.state.meses[i][6][0].valor +
            this.$store.state.meses[i][6][1].valor -
            this.$store.state.meses[i][6][2].valor;
            this.$store.state.meses[i][6][8].valor =
            this.$store.state.meses[i][6][3].valor +
            this.$store.state.meses[i][6][4].valor -
            this.$store.state.meses[i][6][5].valor;
        
      
      //calculando totais dos 2 campos do passo 8 <<

       
          this.$store.state.meses[i][7][10].valor =
            this.$store.state.meses[i][7][0].valor +
            this.$store.state.meses[i][7][1].valor +
            this.$store.state.meses[i][7][2].valor +
            this.$store.state.meses[i][7][3].valor +
            this.$store.state.meses[i][7][4].valor +
            this.$store.state.meses[i][7][5].valor +
            this.$store.state.meses[i][7][6].valor +
            this.$store.state.meses[i][7][7].valor +
            this.$store.state.meses[i][7][8].valor +
            this.$store.state.meses[i][7][9].valor;
        
      
      //calculando totais dos 2 campos do passo 9 <<

       
           this.$store.state.meses[i][8][3].valor =
           this.$store.state.meses[i][8][1].valor * 0.08;
           this.$store.state.meses[i][8][4].valor =
           (this.$store.state.meses[i][8][0].valor +
              this.$store.state.meses[i][8][1].valor +
              this.$store.state.meses[i][8][2].valor) *
              0.2 +
            this.$store.state.meses[i][8][1].valor * 0.088;
            this.$store.state.meses[i][8][5].valor =
            this.$store.state.meses[i][8][0].valor +
            this.$store.state.meses[i][8][1].valor +
            this.$store.state.meses[i][8][2].valor +
            this.$store.state.meses[i][8][3].valor +
            this.$store.state.meses[i][8][4].valor;
        
      
      //calculando totais dos 2 campos do passo 12 <<


          this.$store.state.meses[i][11][9].valor =
            this.$store.state.meses[i][9][0].valor +
            this.$store.state.meses[i][9][1].valor +
            this.$store.state.meses[i][9][2].valor +
            this.$store.state.meses[i][9][3].valor +
            this.$store.state.meses[i][9][4].valor +
            this.$store.state.meses[i][9][5].valor +
            this.$store.state.meses[i][9][6].valor +
            this.$store.state.meses[i][9][7].valor +
            this.$store.state.meses[i][9][8].valor +
            this.$store.state.meses[i][9][9].valor +
            this.$store.state.meses[i][10][0].valor +
            this.$store.state.meses[i][10][1].valor +
            this.$store.state.meses[i][10][2].valor +
            this.$store.state.meses[i][10][3].valor +
            this.$store.state.meses[i][10][4].valor +
            this.$store.state.meses[i][10][5].valor +
            this.$store.state.meses[i][10][6].valor +
            this.$store.state.meses[i][10][7].valor +
            this.$store.state.meses[i][10][8].valor +
            this.$store.state.meses[i][10][9].valor +
            this.$store.state.meses[i][11][0].valor +
            this.$store.state.meses[i][11][1].valor +
            this.$store.state.meses[i][11][2].valor +
            this.$store.state.meses[i][11][3].valor +
            this.$store.state.meses[i][11][4].valor +
            this.$store.state.meses[i][11][5].valor +
            this.$store.state.meses[i][11][6].valor +
            this.$store.state.meses[i][11][7].valor +
            this.$store.state.meses[i][11][8].valor;

            this.$store.state.meses[i][11][10].valor =
            this.$store.state.meses[i][6][7].valor +
            this.$store.state.meses[i][6][8].valor +
            this.$store.state.meses[i][6][9].valor +
            this.$store.state.meses[i][7][10].valor +
            this.$store.state.meses[i][8][5].valor +
            this.$store.state.meses[i][11][9].valor;
        
      //calculando totais dos 2 campos do passo 13 <<

        
          this.$store.state.meses[i][12][18].valor =
            this.$store.state.meses[i][12][0].valor +
            this.$store.state.meses[i][12][1].valor +
            this.$store.state.meses[i][12][2].valor +
            this.$store.state.meses[i][12][3].valor +
            this.$store.state.meses[i][12][4].valor +
            this.$store.state.meses[i][12][5].valor +
            this.$store.state.meses[i][12][6].valor +
            this.$store.state.meses[i][12][7].valor +
            this.$store.state.meses[i][12][8].valor +
            this.$store.state.meses[i][12][9].valor +
            this.$store.state.meses[i][12][10].valor +
            this.$store.state.meses[i][12][11].valor +
            this.$store.state.meses[i][12][12].valor +
            this.$store.state.meses[i][12][13].valor +
            this.$store.state.meses[i][12][14].valor +
            this.$store.state.meses[i][12][15].valor +
            this.$store.state.meses[i][12][16].valor +
            this.$store.state.meses[i][12][17].valor;
        
      
      //calculando totais dos 2 campos do passo 14 <<

        
            this.$store.state.meses[i][13][12].valor =
            this.$store.state.meses[i][13][0].valor +
            this.$store.state.meses[i][13][1].valor +
            this.$store.state.meses[i][13][2].valor +
            this.$store.state.meses[i][13][3].valor +
            this.$store.state.meses[i][13][4].valor +
            this.$store.state.meses[i][13][5].valor +
            this.$store.state.meses[i][13][6].valor +
            this.$store.state.meses[i][13][7].valor +
            this.$store.state.meses[i][13][8].valor +
            this.$store.state.meses[i][13][9].valor +
            this.$store.state.meses[i][13][10].valor +
            this.$store.state.meses[i][13][11].valor;
  }

  },
  props: ["mes", "passomes", "api", "tamanho"],
};
</script>

<style>
.input-gray {
  margin-top: 15px; width: 100%; display:flex; justify-content: flex-start; align-items:center; width:100%; min-height: 60px; background: #EEEEEE
}

.input-title {
  flex-grow: 2;
  justify-self:flex-start
}

.input-title p {
  font-size: 15px !important;
  margin-right: 10px !important;
  display:inline-block; 
  margin: 0 0 0 25px; 
  color: #383838; 
  font-weight: 700
}

.input-info {
  margin-right: 30px;font-size: 16px; color: #AF3437
}

@media screen and (max-width: 800px) {
.input-title p {
  font-size: 10px !important;
  margin-right: 10px;
}
}
</style>